import pluralize from 'pluralize';

import {
  CONCESSION_TYPE_CUSTOM,
  CONCESSION_TYPE_RENT_DISCOUNT,
  CONCESSION_TYPE_RENT_FREE,
  CONCESSION_STATUS_EXPIRED,
  CONCESSION_DESCRIPTION_VARIATION_BANNER,
  CONCESSION_SCHEDULE_TYPE_SECOND_MONTH,
} from 'common/concessionConstants';

import {
  transformConcessionToTextList,
  getConcessionStatus,
  getConcessionEndMoment,
} from 'common/concessionHelpers';
import useCountDownTimer from 'client/hooks/useCountDownTimer';

const useConcessionsBannerController = ({ concession, rentPrice }) => {

  const countDownTimer = useCountDownTimer({
    endDate: getConcessionEndMoment({ concession }),
    includeDays: true,
  });

  const CONCESSION_DURATION_MONTHLY_OPTIONS = [4, 8];

  const _getTitle = () => {
    const {
      type,
      rentFreeWeeks,
      amount,
      customHeadline,
    } = concession;

    switch (type) {
      case CONCESSION_TYPE_RENT_FREE: {
        const titleDetail = CONCESSION_DURATION_MONTHLY_OPTIONS.includes(rentFreeWeeks)
          ? pluralize('Month', rentFreeWeeks / 4, true)
          : pluralize('Week', rentFreeWeeks, true);

        return `*FREE RENT FOR ${titleDetail}*`;
      }
      case CONCESSION_TYPE_RENT_DISCOUNT:
        return `$${amount} Rent Special`;
      case CONCESSION_TYPE_CUSTOM:
        return `*${customHeadline}*`;
      default:
        return '';
    }
  };

  const _getPromotionValidFromText = () => {
    const formattedEndingDate = getConcessionEndMoment({ concession }).format('MMM Do');

    if (concession.scheduleType === CONCESSION_SCHEDULE_TYPE_SECOND_MONTH) {
      return null;
    }

    return (
      'First month rent is paid in full. Discount starts second month, ' +
      `and is prorated over lease term. Special ends ${formattedEndingDate}.`
    );
  };

  const _formatTime = () => {
    const concessionStatus = getConcessionStatus({ concession });
    const selectedTime = countDownTimer.time.split('m')[0];

    if (concessionStatus === CONCESSION_STATUS_EXPIRED) {
      return 'Expired concession';
    }

    return `${selectedTime}m left`;
  };

  return {
    title: _getTitle(),
    remainingTime: _formatTime(),
    concessionDetails: transformConcessionToTextList({
      concession,
      rentPrice,
      variation: CONCESSION_DESCRIPTION_VARIATION_BANNER,
    }),
    validFromText: _getPromotionValidFromText(),
  };
};

export default useConcessionsBannerController;
